<template>
    <v-container class="content-container">
        <v-row>
            <v-col>

                <!-- Heading -->
                <div class="contract-heading d-flex justify-space-between align-center">

                    <!-- Heading text -->
                    <div class="contract-heading__heading ma-0">
                        {{ trainingStore.CurrentSklop!.Name }}
                    </div>

                    <!-- Steps -->
                    <div class="contract-heading__step">
                        <span class="tag tag--white">
                            {{ trainingStore.CurrentVprasanjeId + 1 }}/{{ trainingStore.CurrentSklop!.StVprasanj }}
                            korakov
                        </span>
                    </div>
                </div>

                <!-- Content -->
                <div class="px-8">

                    <!-- End success -->
                    <div class="text-center" v-if="trainingStore.CurrentSklop!.Successful">
                        <div class="section-heading">
                            Čestitamo!
                        </div>
                        <div>
                            Vsi odgovori so bili pravilni. Izobraževanje ste uspešno zaključili, pričnete lahko z delom
                            s pogodbami.
                        </div>
                    </div>

                    <!-- End fail -->
                    <div class="text-center" v-else>
                        <div class="section-heading">
                            Odgovori žal niso bili pravilni.
                        </div>
                        <div>
                            Za uspešno opravljeno izobraževanje morajo biti pravilni vsi odgovori. Izobraževanje lahko
                            ponovite.
                        </div>
                    </div>

                </div>

                <!-- Panel footer -->
                <div class="d-flex ga-4 mt-8 mb-8">
                    <v-btn flat size="x-large" class="btn btn--primary-fill" @click="endTraining()">Zapri</v-btn>
                </div>

            </v-col>
        </v-row>
    </v-container>
</template>

<script setup lang="ts">
    import router from "@app/router";
    import { useTrainingStore } from "@/app/store/app/user-center-trainings/store";

    const trainingStore = useTrainingStore();

    trainingStore.loadTrainingComplete();

    function endTraining() {
        router.push({ name: "trainings" })
    }

</script>
